import { render, staticRenderFns } from "./DepartmentRank.vue?vue&type=template&id=2886c12e&scoped=true"
import script from "./DepartmentRank.vue?vue&type=script&lang=js"
export * from "./DepartmentRank.vue?vue&type=script&lang=js"
import style0 from "./DepartmentRank.vue?vue&type=style&index=0&id=2886c12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886c12e",
  null
  
)

export default component.exports